import { Action } from '../../../shared/xs/actions';
import { ScoringModel } from '../../scoreboard/models/scoring.model';

export class GetLatestScoreAction implements Action {
  static readonly type = '[Scoring] get latest';
}

export type GetLatestImprovementResponse = ScoringModel;
